import { createAsyncStateWithPreloadHook } from '@lib/hooks';

import { coreActions, DataAccessSearchItem } from '@sonar-software/sonar-core';

const empty: Record<string, Array<DataAccessSearchItem>> = {};

/**
 * Subscribes to and returns the collection of Permission Sources. Will load related data upon mount if data is not
 * available or forced via `refresh`.
 * @param refresh Determines if the component should force load the latest data upon mount. Defaults to `false`.
 * @returns A Record with a key of {@link string}, which will be "PermissionSet" or "Profile",
 *          and a value of an array of {@link DataAccessSearchItem}.
 */
export const usePermissionSources = createAsyncStateWithPreloadHook({
	loadAction: coreActions.requestGetCoreDataSecurityDataAccessPermissionSources,
	selector: (state) => state.core.dataSecurity.dataAccess.permissionSources.get,
	useTransform: (request) => request.data || empty
});
